import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { ThemeDrawerType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_DRAWER = {
  borderThickness: 0,
  borderOpacity: 0,
  borderCornerRadius: 0,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 0,
  shadowBlur: 0,
  colorScheme: DEFAULT_THEME_COLOR_SCHEME,
};

export default function ThemeDrawerSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const drawer = builder.theme?.drawer || DEFAULT_THEME_DRAWER;

  const setLayout = (newDrawer: Partial<ThemeDrawerType>) => {
    builder.setTheme({
      drawer: { ...drawer, ...newDrawer },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={drawer.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setLayout({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={drawer.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={drawer.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setLayout({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <InputSlider
        label='Opacity'
        value={drawer.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={drawer.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={drawer.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={drawer.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setLayout({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={drawer.colorScheme || DEFAULT_THEME_COLOR_SCHEME}
        onChange={(theme) => {
          setLayout({ colorScheme: theme });
        }}
      />
      <div className='mb-4 mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
    </div>
  );
}
